module.exports = __webpack_public_path__ + "static/media/16UNODC35.3789c692.jpg";